import React from 'react';
import { TopBar } from '../components/TopBar';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Experiences } from '../components/Experiences';
import { Gallery } from '../components/Gallery';
import { HowWeWork } from '../components/HowWeWork';
import { MiddleText } from '../components/MiddleText';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
import { LanguageProvider } from '../lib/i18n';
export function PicnicTenerifePage() {
  return <LanguageProvider data-id="element-301" data-mp="ch99jh4rr2ub">
      <div className="bg-sand text-volcanic min-h-screen overflow-x-hidden font-sans selection:bg-terracotta selection:text-ivory" data-id="element-302" data-mp="cfoi40dr400o">
        <TopBar data-id="element-303" data-mp="hhxc902d184d" />
        <Navbar data-id="element-304" data-mp="rraao6bu15xu" />
        <Hero data-id="element-305" data-mp="rrsg9tkdwwif" />
        <About data-id="element-306" data-mp="rrk3s2s6bt7r" />
        <Experiences data-id="element-307" data-mp="rpz9me9rucaf" />
        <Gallery data-id="element-308" data-mp="rqha5n3gvco5" />
        <HowWeWork data-id="element-309" data-mp="roxt3u9zkxlb" />
        <Testimonials data-id="element-310" data-mp="np5k5ggokpff" />
        <MiddleText data-id="element-311" data-mp="nqqfh8atkcec" />
        <FAQ data-id="element-312" data-mp="nq6z3w0thw2f" />
        <FinalCTA data-id="element-313" data-mp="nnknnlat2wex" />
        <Contact data-id="element-314" data-mp="iqlvh8apczjd" />
        <Footer data-id="element-315" data-mp="iq2najautpij" />
        <FloatingWhatsApp data-id="element-316" data-mp="ipj7p98ofd7o" />
      </div>
    </LanguageProvider>;
}